import Bugsnag from '@bugsnag/js'

export const setLogContext = Bugsnag.setContext
